/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RefreshOrganizationRemoteSessionSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type RefreshOrganizationRemoteSessionRequest = {
  /**
   * The remote_session id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type RefreshOrganizationRemoteSessionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const RefreshOrganizationRemoteSessionSecurity$outboundSchema:
  z.ZodMiniType<
    RefreshOrganizationRemoteSessionSecurity$Outbound,
    RefreshOrganizationRemoteSessionSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function refreshOrganizationRemoteSessionSecurityToJSON(
  refreshOrganizationRemoteSessionSecurity:
    RefreshOrganizationRemoteSessionSecurity,
): string {
  return JSON.stringify(
    RefreshOrganizationRemoteSessionSecurity$outboundSchema.parse(
      refreshOrganizationRemoteSessionSecurity,
    ),
  );
}

/** @internal */
export type RefreshOrganizationRemoteSessionRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const RefreshOrganizationRemoteSessionRequest$outboundSchema:
  z.ZodMiniType<
    RefreshOrganizationRemoteSessionRequest$Outbound,
    RefreshOrganizationRemoteSessionRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
      });
    }),
  );

export function refreshOrganizationRemoteSessionRequestToJSON(
  refreshOrganizationRemoteSessionRequest:
    RefreshOrganizationRemoteSessionRequest,
): string {
  return JSON.stringify(
    RefreshOrganizationRemoteSessionRequest$outboundSchema.parse(
      refreshOrganizationRemoteSessionRequest,
    ),
  );
}
